import { SampleBuggyButton } from "@highlight-run/react";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/lab/error")({
  component: RouteComponent,
});

function RouteComponent() {
  return <SampleBuggyButton />;
}
